import BaseView from './BaseView';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let view = null;

class Homepage extends BaseView {
	constructor(container) {
		super(container);
	}
	init() {
		const textBlocks = this.container.querySelectorAll('[data-scroll-text]');

		let mm = gsap.matchMedia();

		mm.add('(max-width: 992px)', () => {
			textBlocks.forEach((block) => {
				ScrollTrigger.create({
					trigger: block,
					start: 'top-=205px top',
					end: 'bottom-=205px top',
					toggleClass: 'active',
				});
			});

			return () => {};
		});
	}
}

export default {
	namespace: 'template-homepage',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Homepage(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
